function structuredCloneSafe(value) {
  try {
    return structuredClone(value)
  } catch (e) {
    // Fallback to JSON serialization and deserialization
    const serializedValue = JSON.stringify(value)
    const deserializedValue = JSON.parse(serializedValue)
    return deserializedValue
  }
}

export { structuredCloneSafe }
